import React from "react";
import { useAppTranslation } from "@/utils/useAppTranslation";

/**
 * Display `messages` in list or single text based on `prop` length
 * @default []
 */
const ModalConfirmGenerator: React.FC<{ messages: string[] }> = ({ messages = [] }) => {
  const { t } = useAppTranslation();
  if (messages.length === 1) {
    return (
      <>
        <p>{messages}</p>
        <p>{t("token.areYouSure")}</p>
      </>
    );
  }
  if (messages.length > 1) {
    return (
      <>
        <ul>
          {messages.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </ul>
        <p>{t("token.areYouSure")}</p>
      </>
    );
  }
  return null;
};

export default ModalConfirmGenerator;
